<template>
    <div>
        <div class="bgstyle bg-primary-orange overflow-hidden pb-10 md:px-10">
            <div class=" md:text-center newsrow">
            <ul class="news md:inline-block md:text-left">
                <li v-for="newsItem in articleItem" :key="newsItem.ID" v-if="newsItem.title" class="text-xl pt-3 mt-8 md:pr-6">
                    <teaser-view :news="newsItem"></teaser-view>
                </li>
            </ul>
        </div>
        </div>
        <the-more><router-link to="/news"><the-language de="mehr" en="more" /></router-link></the-more>
        <seperator />
    </div>
</template>


<script>

    import teaserView from './teaserView'
    import seperator from '../seperatorFullWidth'
    import TheMore from '../TheMore'
    import TheLanguage from "../TheLanguage";

    export default {
        name: 'News',
        components: {
            teaserView,
            seperator,
            TheMore,
            TheLanguage
        },
        data() {
            return {

            }
        },

        props: {
            articleItem: {
                type: Object,
                default: () => {
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
    .bgstyle{
        background-image: url('http://api.pgsi2020.de/images/background_news.png');
        background-repeat: no-repeat;
        background-size: contain;
        @screen md {
            background-size: 30%;
        }
        background-position: top right;
    }

    @screen md {

        .newsrow{
            max-width: 1800px;
            margin: 0 auto;
        }

        ul.news li{
            width: 50%;
            display: inline-block;
            vertical-align: top;
            img{
                border: 20px solid transparent;
                //@apply border-primary-green;
                transition: all ease-in .4s;
            }
            &:hover{
                img{
                    border: 20px solid red;
                    @apply border-primary-green;
                }
                h2{
                    box-shadow: 0 0px 30px 3px rgba(0, 0, 0, 0.7)
                }
            }
        }
    }

</style>